import { ErrorHandler, Injectable } from '@angular/core';

/**
 * Errors that are noise from the browser environment and cannot be fixed in application code.
 * These are filtered out to keep the console clean without hiding real errors.
 */
const SUPPRESSED_ERRORS: string[] = [
    // Chrome extension message channels that close before their async listener responds.
    // Caused by browser extensions (password managers, ad blockers, dev tools etc.) and
    // is not an application error.
    'A listener indicated an asynchronous response by returning true, but the message channel closed before a response was received',
];

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    handleError(error: any): void {
        const message: string = error?.message ?? error?.toString() ?? '';

        if (SUPPRESSED_ERRORS.some(suppressed => message.includes(suppressed))) {
            return;
        }

        // Delegate all other errors to the default Angular behaviour.
        console.error(error);
    }
}